// extracted by mini-css-extract-plugin
module.exports = {"icon":"SharedSoulBreakList_icon__3UfIF","unowned":"SharedSoulBreakList_unowned__1ccX7"};